<template>
    <transition name="fade" >
        <div v-show="visible" class="cbd-toast" :style="{top:top}">
            <span>{{title}}</span>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
      title: {
        default: '成功'
      },
      top: {
        default: '50%'
      },
    },
    data () {
        return {
            visible: false
        }
    },
    methods: {
        show () {
            this.visible = true
        },
        hide () {
            this.visible = false
        }
    }
}
</script>

<style lang="less" scoped>
    .cbd-toast {
        position: fixed;
        left: 50%;
        transform: translate(-50%);
        padding: 28px 40px;
        border-radius: 6px;
        font-size: 30px; /* px */
        color: #E5E5E5;
        background: rgba(0,0,0,0.80);
        text-align: justify;
        z-index: 2002;

        span {
            white-space: nowrap;
        }
        .fade-enter-active, .fade-leave-active {
            transition: opacity 2.5s;
        }
        .fade-enter, .fade-leave-to {
            opacity: 0;
        }
    }
</style>
